module.exports = __webpack_public_path__ + "img/scroll_up.42cbfa7b.svg";